import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Notification } from '../../../common/notification'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { ChartContainer } from './components/chartScore'
import { Header } from './components/Header'
import { loadingYourPortfolio, selectPortfolio } from './store/slice'
import {
  getCreditRiskScore,
  getPerformanceScore,
  getSavedPortfolio,
} from './store/thunk'

export const YourPortfolio = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const activePortfolio = useSelector(selectPortfolio('activePortfolio'))
  const loadingSaved = useSelector(loadingYourPortfolio('getPortfolio'))
  const loadingCredit = useSelector(loadingYourPortfolio('creditRiskScore'))
  const loadingPerformance = useSelector(
    loadingYourPortfolio('performanceScore'),
  )
  const userType = useSelector(selectUserType)
  const isActiveFeature = useMemo(
    () =>
      [USER_TYPE.STANDARD, USER_TYPE.LITE, USER_TYPE.BASIC].includes(
        userType.userTypeId,
      ),
    [],
  )

  useEffect(() => {
    dispatch(getCreditRiskScore({ PortfolioId: activePortfolio?.value }))
    dispatch(getPerformanceScore({ PortfolioId: activePortfolio?.value }))
  }, [activePortfolio?.value, locale])

  useEffect(() => {
    dispatch(getSavedPortfolio())
  }, [])

  return (
    <>
      <LayoutPanel
        loading={loadingSaved || loadingCredit || loadingPerformance}
        style={{ height: '100%' }}
      >
        <div className="flexColumn h100">
          <Header isActiveFeature={isActiveFeature} />
          <div className="flex1">
            {!isActiveFeature ? (
              <>
                {loadingCredit || loadingPerformance ? (
                  <></>
                ) : (
                  <ChartContainer />
                )}
              </>
            ) : (
              <>
                <Notification
                  value="dashboard.yourPortfolio.canUpgrade"
                  style={{ textAlign: 'center' }}
                />
              </>
            )}
          </div>
        </div>
      </LayoutPanel>
    </>
  )
}
